import { render } from "./war.vue?vue&type=template&id=512610f9&ts=true"
import script from "./war.vue?vue&type=script&lang=ts"
export * from "./war.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/gkozyrev/Desktop/Projects/Ginoice/Projects/Dmitry_Voloshin-dornn/cybercola/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__